// src/escape-keydown.ts
import { addDomEvent } from "@zag-js/dom-event";
import { getDocument } from "@zag-js/dom-query";
function trackEscapeKeydown(node, fn) {
  const handleKeyDown = (event) => {
    if (event.key === "Escape")
      fn?.(event);
  };
  return addDomEvent(getDocument(node), "keydown", handleKeyDown);
}

export {
  trackEscapeKeydown
};
